import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiSmartButtonAPIKey = new PluginKey('aiSmartButtonAPI');
